import React from 'react';
import PropTypes from 'prop-types';

function TabPanel(props) {
    const { children, value, index,} = props;
    
    return (
        <>
        {value === index && 
        <>
        {children}
        </>}
        </>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
    };

export default TabPanel;